export function windowScrollSource() {
    return {
        y: () => window.scrollY,
        viewport: () => ({ width: window.innerWidth, height: window.innerHeight }),
        documentTop: (element) => element.getBoundingClientRect().top + window.scrollY,
        positionCanvas(canvas, mode) {
            if (mode === "pinned") {
                canvas.style.position = "";
                canvas.style.top = "";
                canvas.style.height = "";
            }
            else {
                canvas.style.position = "absolute";
                canvas.style.top = `${Math.round(mode.releasedTop)}px`;
                canvas.style.height = `${window.innerHeight}px`;
            }
        },
    };
}
export function containerScrollSource(options) {
    const zoom = () => options.zoom() || 1;
    const frameRect = () => options.frame()?.getBoundingClientRect() ?? null;
    const y = () => {
        const frame = frameRect();
        const section = options.section()?.getBoundingClientRect();
        if (!frame || !section)
            return 0;
        return Math.max(0, (section.top - frame.top) / zoom());
    };
    return {
        y,
        viewport: () => {
            const frame = options.frame();
            const section = options.section();
            return {
                width: frame?.clientWidth ?? 1,
                height: (section?.clientHeight ?? 1) / zoom(),
            };
        },
        documentTop: (element) => {
            const frame = frameRect();
            if (!frame)
                return 0;
            return (element.getBoundingClientRect().top - frame.top) / zoom();
        },
        positionCanvas(canvas, mode, scrollY) {
            const section = options.section();
            canvas.style.position = "absolute";
            canvas.style.left = "0";
            canvas.style.width = "100%";
            canvas.style.height = `${(section?.clientHeight ?? 1) / zoom()}px`;
            canvas.style.top = `${Math.round(mode === "pinned" ? scrollY : mode.releasedTop)}px`;
        },
    };
}
//# sourceMappingURL=scroll-source.js.map